import axios from 'axios'

class ShareHealthVaultDocuments {
  constructor() {
    this.baseUrl = '/api/v1/'
  }

  verifyRecipientInfo(data) {
    return axios.post(
      `${this.baseUrl}sharing/validate-recipient-details/`,
      data
    )
  }

  getRecipientRelationshipDuration() {
    return axios.get(
      `${this.baseUrl}sharing/get-recipient-relationship-duration/`
    )
  }

  saveRecipientInformation(data) {
    return axios.post(
      `${this.baseUrl}healthvaults/save-hv-recipient-details/`,
      data
    )
  }

  vaidateDocumentUrl(obj) {
    return axios.post(`${this.baseUrl}healthvaults/link-validation/`, obj)
  }
}

export const shareHealthVaultDocuments = new ShareHealthVaultDocuments()
